import React from "react";

import SupplierMenuList from "./SupplierMenuList";
import styles from './MenuList.module.css';
import SupplierSearch from "./SupplierSearch";

const AllMenuList = (props) => {

  const [ supplierId, setSupplierId ] = React.useState(-1);

  const handleChange = (supplier) => {
    if (supplierId !== supplier?.id) {
      setSupplierId(supplier?.id ?? -1);
    }
  }

  return (
    <div className={styles.root}>
      <div className={styles.title}>전체메뉴</div>
      <div>
        <SupplierSearch
          onChange={handleChange} />
      </div>
      <div>
        <SupplierMenuList 
          supplierId={supplierId} />
      </div>
    </div>
  );
}

export default AllMenuList;